export const extractDomain = (url: string): string => {
  const originalUrl = url; // Save the original URL
  try {
    // If no protocol is provided, default to https
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    const { hostname } = new URL(url);
    const parts = hostname.split('.');

    // If it's something like www.example.com, we want "example.com"
    if (parts.length > 2 && parts[0] === 'www') {
      parts.shift();
    }

    return parts.join('.');
  } catch (e) {
    // Invalid URL or some other error
    return originalUrl; // Return the original URL if there's an error
  }
};
